import { render } from "./add-discount.vue?vue&type=template&id=7cc85625&scoped=true"
import script from "./add-discount.vue?vue&type=script&lang=js"
export * from "./add-discount.vue?vue&type=script&lang=js"

import "./add-discount.vue?vue&type=style&index=0&id=7cc85625&lang=css"
import "./add-discount.vue?vue&type=style&index=1&id=7cc85625&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc85625"]])

export default __exports__